export const profile = {
  experience: [
    {
      role: "Contributor",
      company: "GSSoC 2026",
      period: "May 2026 - August 2026",
      summary:
        "Contributing to open-source projects as part of GirlScript Summer of Code 2026 (GSSoC'26), Open Source Track. Working on real-world codebases, collaborating with the global developer community, and building impactful software solutions.",
    },
    {
      role: "Contributor - TechSprint Hackathon",
      company: "GDG Charusat",
      period: "February 2026 - 7 days",
      summary:
        "Open-source hackathon participation focused on collaborative development, version control systems, and practical engineering workflows.",
    },
  ],
};
